module.exports = __webpack_public_path__ + "img/GAME_SWEEPLEAVES2.08db65be.jpg";